import React from 'react';
import NewcommerIcon from '../../assets/newcomer-icon.svg';
import ContributorIcon from '../../assets/contributor-icon.svg';
import RespectedIcon from '../../assets/respected-icon.svg';
import AuthorityIcon from '../../assets/authority-icon.svg';
import LuminaryIcon from '../../assets/luminary-icon.svg';

const RankBadge = ({ rank, textSize, iconSize, isBlur = false, hiddenRankText, ...rest }) => {
  const badges = {
    newcomer: {
      icon: NewcommerIcon,
      label: 'Newcomer',
      gradient: 'linear-gradient(90deg, #333333 13%, #6C6C6C 41.5%, #A5A5A5 75.5%)'
    },
    contributor: {
      icon: ContributorIcon,
      label: 'Contributor',
      gradient: 'linear-gradient(90deg, #0054C0 9%, #1E71DB 49.5%, #4697FF 84.5%)'
    },
    respected: {
      icon: RespectedIcon,
      label: 'Respected',
      gradient: 'linear-gradient(90deg, #204A22 18.32%, #459F49 55.58%, #459F49 90.92%)'
    },
    authority: {
      icon: AuthorityIcon,
      label: 'Authority',
      gradient: 'linear-gradient(90deg, #C987DF 12%, #BB54DD 50.5%, #A405D9 92%)'
    },
    luminary: {
      icon: LuminaryIcon,
      label: 'Luminary',
      gradient: 'linear-gradient(180deg, #FF7D4E 6.5%, #FDA704 52%, #FFC15C 92.5%)'
    }
  };

  const badgeInfo = badges[rank?.toLowerCase()] || badges.newcomer;

  const containerStyle = {
    position: 'relative',
    padding: '1px',
    background: isBlur ? '#D4D4D4' : badgeInfo.gradient,
    borderRadius: '9999px',
    display: 'inline-block',
    opacity: isBlur ? 0.5 : 1
  };

  const contentStyle = {
    background: 'white',
    borderRadius: '9999px',
    display: 'flex',
    alignItems: 'center'
  };

  const textStyle = {
    display: 'inline-block',
    fontWeight: '800',
    position: 'relative',
    backgroundImage: isBlur
      ? 'linear-gradient(90deg, #D4D4D4 0%, #D4D4D4 100%)'
      : badgeInfo.gradient,
    backgroundSize: '100%',
    WebkitBackgroundClip: 'text',
    MozBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    color: 'transparent',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  const imageStyle = {
    filter: isBlur ? 'grayscale(100%)' : 'none',
    opacity: isBlur ? 0.5 : 1
  };

  return (
    <div
      style={containerStyle}
      className="hover:shadow-md transition-shadow duration-200 border-1 h-fit"
      {...rest}
    >
      <div style={contentStyle} className="p-1 gap-1">
        <img
          className={`${iconSize || 'w-4 h-4'}`}
          src={badgeInfo.icon}
          alt=""
          style={imageStyle}
        />
        {!hiddenRankText && (
          <span style={textStyle} className={`${textSize || 'text-xs'}`}>
            {badgeInfo.label}
          </span>
        )}
      </div>
    </div>
  );
};

export default RankBadge;
